
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Options({
  emits: ['evidence-changed']
})

export default class EvidenceSelector extends Vue {
  @Prop(Number) readonly amount!: number;
  @Prop(Array) readonly evidenceOptions!: string[];
  evidence = Array(this.amount).fill('').map((value, index) => ({
    number: index + 1,
    value: '',
    disabled: index > 0,
    evidenceOptions: this.evidenceOptions
  }))

  onEvidenceChanged() {
    // First update disabled and value properties.
    for (let i = 1; i < this.evidence.length; i++) {
      const evidence = this.evidence[i]
      const prevEvidence = this.evidence[i - 1]

      // Determine if selector should be disabled, if so also remove value.
      const disabled = prevEvidence && !prevEvidence.value
      evidence.disabled = disabled
      if (disabled) evidence.value = ''
    }

    // Then update evidence options.
    const { evidenceValues } = this
    for (let i = 0; i < this.evidence.length; i++) {
      const evidence = this.evidence[i]

      // Remove already selected options from all other selectors.
      evidence.evidenceOptions = this.evidenceOptions.filter(value => {
        for (let j = 0; j < evidenceValues.length; j++) {
          if (j !== i && evidenceValues[j] === value) return false
        }

        return true
      })
    }

    this.$emit('evidence-changed', this.evidenceValues)
  }

  resetEvidence() {
    for (let i = 0; i < this.evidence.length; i++) {
      this.evidence[i].value = ''
    }

    this.onEvidenceChanged()
  }

  get evidenceValues() {
    return this.evidence.map(evidence => evidence.value)
  }
}
